"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../styles/_quick-access.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var QuickAccessPanel = /*#__PURE__*/function (_Component) {
  _inherits(QuickAccessPanel, _Component);

  function QuickAccessPanel(props) {
    var _this;

    _classCallCheck(this, QuickAccessPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(QuickAccessPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onLinkClick", function (hash) {
      var _this$props = _this.props,
          history = _this$props.history,
          scrollTo = _this$props.scrollTo;
      var location = history.location;

      _this.setState({
        activeHash: hash
      }, function () {
        scrollTo(hash);
        history.replace("".concat(location.pathname, "#").concat(hash));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDownHandler", function (e, hash) {
      e.preventDefault();

      if (e.key === 'Enter') {
        _this.onLinkClick(hash);
      }
    });

    _this.state = {
      activeHash: props.initialHash
    };
    return _this;
  }

  _createClass(QuickAccessPanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var hashList = this.props.hashList;
      var activeHash = this.state.activeHash;
      return _react.default.createElement(_react.default.Fragment, null, hashList.map(function (_ref) {
        var hash = _ref.hash,
            title = _ref.title;
        return _react.default.createElement("div", {
          key: hash,
          tabIndex: 0,
          role: "button",
          className: (0, _classnames.default)('link', {
            selected: hash === activeHash
          }),
          onKeyDown: function onKeyDown(e) {
            return _this2.onKeyDownHandler(e, hash);
          },
          onClick: function onClick() {
            return _this2.onLinkClick(hash);
          }
        }, title);
      }));
    }
  }]);

  return QuickAccessPanel;
}(_react.Component);

var _default = QuickAccessPanel;
exports.default = _default;